import { ApiAnalyticsGroupBy } from "@/types/analytics/analytics.recruiting.types.ts";
import {
  SelectItem,
  Button,
  DropdownMenu,
  DropdownMenuItem,
  FontAwesomeIcon,
} from "@skailer-com/uikit";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export interface ButtonChooseGroupByProps {
  value: string | null | undefined;
  onChange: (group: string) => void;
}

export const RecruitingReportingButtonChooseGroupBy = ({
  value,
  onChange,
}: ButtonChooseGroupByProps) => {
  const { t } = useTranslation();
  const groupByOptions: SelectItem[] = [
    {
      id: ApiAnalyticsGroupBy.job,
      title: `${t("common:grouping")}:  ${t("ats:job")}`,
    },
    {
      id: ApiAnalyticsGroupBy.owner,
      title: `${t("common:grouping")}:  ${t("ats:recruiter")}`,
    },
    {
      id: ApiAnalyticsGroupBy.none,
      title: `${t("common:grouping")}:  ${t("common:date")}`,
    },
  ];
  const selectedGrouping = useMemo(() => {
    const groupType = value || ApiAnalyticsGroupBy.none;
    return groupByOptions.find((x) => x.id == groupType);
  }, [value]);

  return (
    <DropdownMenu
      trigger={
        <Button
          variant={"secondary"}
          rightIcon={<FontAwesomeIcon icon={"fa-light fa-chevron-down shrink-0"} />}
        >
          {selectedGrouping?.title}
        </Button>
      }
    >
      {groupByOptions.map((option: SelectItem) => (
        <DropdownMenuItem
          key={`group-by-${option.id} `}
          title={option.title}
          isSelected={
            value?.toString() == option.id.toString() ||
            (value == null && option.id == ApiAnalyticsGroupBy.none)
          }
          onClick={() => {
            onChange(option.id.toString());
          }}
        />
      ))}
    </DropdownMenu>
  );
};
